function decodeContent(options = {}) {
  const {
    contentKey = 'content',
    itemsKey = 'items',
    nameKey = 'name',
    titleKey = 'title'
  } = options;

  return (data = {}) =>
    data.map((item, i) => ({
      id: i,
      name: item[nameKey],
      items: (item[itemsKey] || []).map((sec, j) => ({
        id: `${i}.${j}`,
        title: sec[titleKey],
        content: sec[contentKey]
      }))
    }));
}

export default decodeContent;
